// extracted by mini-css-extract-plugin
export default {"whenColumn":"logs_table_whenColumn__huVlD","eventColumn":"logs_table_eventColumn__x9Mui"};